const CaretDown = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.3 40.28">
            <path
                fill="#010101"
                d="M14.74 -3.76H22.740000000000002V41.24H14.74z"
                transform="rotate(-45 18.741 18.737)"
            ></path>
            <path
                fill="#010101"
                d="M24.67 16.14H73.64V24.14H24.67z"
                transform="rotate(-45 49.161 20.137)"
            ></path>
        </svg>
    )
}

export default CaretDown
